import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default defineComponent({
  name: 'BlockImageList',
  components: {
    ItemTripleTextImage: function ItemTripleTextImage() {
      return import('~/components/cms/custom/ItemTripleTextImage.vue');
    }
  },
  props: {
    title: String,
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  }
});